import { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';

/**
 * ハブ内ページ表示時に SSO セッション（licenses / clinic 等）を再取得する。
 * ライセンス契約・決済変更の反映用。
 */
export function useRefreshHubSessionOnMount() {
  const { onRefreshSession } = useOutletContext() || {};

  useEffect(() => {
    onRefreshSession?.();
  }, [onRefreshSession]);
}
